(function(){
    'use strict'; 
    angular.module('Services').service('RememberMeService', RememberMeService);
    RememberMeService.$inject = ['$cookies', 'jwtHelper'];

    function RememberMeService($cookies, jwtHelper) {
        const key = 'LX1392929MMMG23131XX03';

        const isRememberLabel = '_is';
        const refreshTokenLabel = '_rr';

        function generateCookieOpt(refreshToken) {
            const token = jwtHelper.decodeToken(refreshToken);
            const expDate = getExpDate(token.exp);
            
            return {
                expires: expDate,
                path: '/',
                secure: false
            }
        }

        function getExpDate(expInSec) {
            const expDate = new Date();
            const expInMins = ((expInSec / 1000) / 60);

            expDate.setMinutes(expDate.getMinutes() + expInMins);
            return expDate;
        }

        return {
            /**
             * Get the remember me value
             * 
             * @return bool
             */
            getRememberMe: () => {
                const isRememberMe = $cookies.get(isRememberLabel);
                return angular.fromJson(isRememberMe);
            },
            /**
             * Save the remember me related token value
             * 
             * @param {string} refreshToken - refresh token
             * 
             * @return null
             */
            setRememberMeTokens: (refreshToken) => {
                const cookieOpt = generateCookieOpt(refreshToken);
                const encryptedRefreshToken = CryptoJS.AES.encrypt(refreshToken, key);
                $cookies.put(refreshTokenLabel, encryptedRefreshToken.toString(), cookieOpt);
            },
            /**
             * Get the rember me related tokens
             * 
             * @return {string} - refreshToken
             */
            getRememberMeTokens: () => {
                const refreshToken =  $cookies.get(refreshTokenLabel); 
                if (!refreshToken) { return; }
                return CryptoJS.AES.decrypt(refreshToken, key).toString(CryptoJS.enc.Utf8);          
            },
            /**
             * Clear the remember me related cookies
             * 
             * @return null
             */
            removeRememberMeTokens: () => {
                $cookies.remove(isRememberLabel);
                $cookies.remove(refreshTokenLabel);
            }
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/RememberMeService.js